module.exports = __webpack_public_path__ + "static/img/transportTitle.787cf8b3.png";